import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import * as dealModeSelectors from '@makemydeal/dr-dash-store/selectors/dealModeSelectors';

import { AioErrorReasons, AioErrorTitle, AioErrorAlertContainer } from './AioErrorAlert.style';

export const AioErrorAlert = () => {
    const aioFailures = useSelector(baseDealSelectors.getAioFSFailures);
    const showUpdateOfferForFSEvents = useSelector(baseDealSelectors.getShowUpdateOfferForFSEvents);
    const isFsSyncFailureMessagingEnabled = useSelector(featureToggleSelectors.isFsSyncFailureMessagingEnabled);
    const isFnIDealMode = useSelector(dealModeSelectors.isFnIDealMode);
    const title = "We couldn't submit your deal to Dealertrack";

    const failureMessagesWithCode = useMemo(() => {
        if (!aioFailures?.length) return [];

        return aioFailures.map((aioFailure) => ({
            code: aioFailure.code || '',
            message: aioFailure.message || aioFailure.properties?.[0]?.message || ''
        }));
    }, [aioFailures]);

    // Don't show if the UpdateOfferWithFSEvents modal is showing
    if (showUpdateOfferForFSEvents) {
        return null;
    }

    if (isFsSyncFailureMessagingEnabled && isFnIDealMode) {
        return null;
    }

    if (!Array.isArray(aioFailures) || !aioFailures || aioFailures.length === 0) {
        return null;
    }
    // istanbul ignore next
    const failures = failureMessagesWithCode?.map((failure, index) => (
        <li key={`${failure.code || 'failure'}-${index}`} data-testid={`aio-error-message-${failure.code}-${index}`}>
            <Typography variant="body-sm">{failure.message}</Typography>
        </li>
    ));

    return (
        <AioErrorAlertContainer>
            <Alert type="error" data-testid="save-offer-aio-failure" disableSuccessFade>
                <AioErrorTitle variant="h6">{title}</AioErrorTitle>
                {failureMessagesWithCode.length === 1 ? (
                    <Typography variant="body-sm">{failureMessagesWithCode[0].message}</Typography>
                ) : (
                    <AioErrorReasons>{failures}</AioErrorReasons>
                )}
            </Alert>
        </AioErrorAlertContainer>
    );
};
